import { render, staticRenderFns } from "./PopUpAnswerFileAguasAndinas.vue?vue&type=template&id=31777feb&scoped=true&"
import script from "./PopUpAnswerFileAguasAndinas.vue?vue&type=script&lang=js&"
export * from "./PopUpAnswerFileAguasAndinas.vue?vue&type=script&lang=js&"
import style0 from "./PopUpAnswerFileAguasAndinas.vue?vue&type=style&index=0&id=31777feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31777feb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31777feb')) {
      api.createRecord('31777feb', component.options)
    } else {
      api.reload('31777feb', component.options)
    }
    module.hot.accept("./PopUpAnswerFileAguasAndinas.vue?vue&type=template&id=31777feb&scoped=true&", function () {
      api.rerender('31777feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpAnswerFileAguasAndinas.vue"
export default component.exports